angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetClickRateGraph', ($q, $translate, BaseCampaignInterestWidgetGraph, Chart) ->
  class Graph extends BaseCampaignInterestWidgetGraph
    link: (scope, element, attrs) ->
      addSeries = (click_item_rate_stats) ->
        scope.chartConfig.series = [
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetClickRateGraph.productClick')
          data: click_item_rate_stats
        ]

      scope.getStats = ->
        $q.all [
          scope.getCampaignEventStats('click_badge')
          scope.getCampaignEventStats('click_item')
        ]

      scope.getChartConfig = ->
        scope.chartConfig = Chart.getChartConfig 'line',
          options:
            tooltip:
              valueSuffix: '%'
              valueDecimals: 2
            legend: false

      scope.addChartConfig = ([badge_click_stats, click_item_stats]) ->
        click_item_count_by_start_at = {}
        for click_item_stat in click_item_stats
          start_at = click_item_stat.start_at.valueOf()
          click_item_count_by_start_at[start_at] = click_item_stat.count
        click_item_rate_stats = []
        for badge_click_stat in badge_click_stats
          start_at = badge_click_stat.start_at.valueOf()
          click_item_count = click_item_count_by_start_at[start_at] or 0
          click_item_rate = if badge_click_stat.count then click_item_count / badge_click_stat.count * 100 else 0
          click_item_rate_stats.push [start_at, click_item_rate]
        addSeries(click_item_rate_stats)

  return new Graph('daily').createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_click_rate_graph.coffee